import * as React from "react";
import { forwardRef } from "react";
const ThirdRowSeatsIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M15.243 1.25a3.5 3.5 0 0 1 3.508 3.491v1.41c.189.088.377.179.563.274l.45.24.065.041a.75.75 0 0 1-.792 1.272c-.095-.053-.19-.104-.286-.154V20.63c0 1.175-.958 2.12-2.129 2.121H7.48a2.125 2.125 0 0 1-2.128-2.121V7.837c-.125.068-.248.138-.37.21a.75.75 0 0 1-.76-1.293c.37-.218.748-.417 1.13-.6V4.74A3.5 3.5 0 0 1 8.858 1.25h6.385Zm2.008 5.892c-3.328-1.295-7.051-1.345-10.4-.01v13.497c0 .339.277.621.628.621h9.143a.626.626 0 0 0 .629-.621V7.142ZM8.858 2.75a2 2 0 0 0-2.007 1.991v.788c3.382-1.197 7.057-1.15 10.4.014v-.802a2 2 0 0 0-2.008-1.991H8.858Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.672 8.104a.75.75 0 0 1 0 1.492l-.076.004H8.55a.75.75 0 0 1 0-1.5h2.046l.076.004ZM15.572 8.104a.75.75 0 0 1 0 1.492l-.076.004H13.45a.75.75 0 0 1 0-1.5h2.046l.076.004ZM15.278 12.304c.349.038.622.358.622.746s-.273.708-.622.746l-.07.004H8.792c-.382 0-.692-.336-.692-.75s.31-.75.692-.75h6.416l.07.004ZM15.278 17.104c.349.038.622.358.622.746s-.273.708-.622.746l-.07.004H8.792c-.382 0-.692-.336-.692-.75s.31-.75.692-.75h6.416l.07.004Z"
}));
const ForwardRef = forwardRef(ThirdRowSeatsIcon);
export default ForwardRef;